import { render, staticRenderFns } from "./CollapseVertical.vue?vue&type=template&id=1074f122"
import script from "./CollapseVertical.vue?vue&type=script&lang=js"
export * from "./CollapseVertical.vue?vue&type=script&lang=js"
import style0 from "./CollapseVertical.vue?vue&type=style&index=0&id=1074f122&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports